import wx from 'weixin-js-sdk'
import {
    fetch
} from '../request/http.js'
const BaseUrl = window.location.href.split('#')[0]
const imgUrl = `${location.origin}/static/logo.png`
// 存储各个链接的签名信息
const signMap = new Map()
// 设置默认的分享信息，因为如分享图、请求授权项、隐藏授权项等基本不变，此处设置直接引用，避免使用时繁琐设置
const defaultWxShareConfig = {
    // 标题
    title: '知识服务平台',
    // 描述， 微信卡片最多可以展示30个字符 3行
    desc: '知识服务平台是隧道网打造的电子资料服务栏目，基于长期沉淀的丰富的施工经验和大量国际前沿技术工法，旨在为广大网友提供更多有价值的信息和技术资料。',
    // 鉴权链接
    link: BaseUrl,
    // 分享链接
    shareLink: BaseUrl,
    // 分享图片
    imgUrl: imgUrl,
    // 请求授权项
    jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareAppMessage',
        'onMenuShareTimeline'
    ]
}
// 存储临时的分享信息
const wxShareConfig = {}
const wxShare = {
    // 各个页面加载后，调用此方法，传入的参数config是对象，其属性参考defaultWxShareConfig
    updateWxShareConfig(config = {}) {
        wxShareConfig.title = config.title || defaultWxShareConfig.title
        wxShareConfig.desc = config.desc || defaultWxShareConfig.desc
        wxShareConfig.link = config.link || defaultWxShareConfig.link
        wxShareConfig.imgUrl = config.imgUrl || defaultWxShareConfig.imgUrl || imgUrl
        wxShareConfig.jsApiList = config.jsApiList || defaultWxShareConfig.jsApiList
        wxShareConfig.shareLink = config.shareLink || defaultWxShareConfig.shareLink
        // 跳转地址
        let authUrl = wxShareConfig.link || BaseUrl
        const ua = navigator.userAgent
        const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
            // os系统，授权地址必须使用第一次打开时候的地址，中途换的地址不识别
            authUrl = wxShareConfig.link
        }
        // 判断是否已经签名了
        if (signMap.has(authUrl)) {
            // 使用已有签名信息
            this.wxConfigJSSDK(signMap.get(authUrl))
        } else {
            // 请求鉴权接口
            this.wxShareAuth(authUrl)
        }
    },

    // 从服务器获取某分享链接的签名信息，并存储起来，注意该接口一定要使用公众号的appid和AppSecret
    async wxShareAuth(authUrl) {
        const postData = {
            url: authUrl
        }
        const res = await fetch("/signature", postData, { baseURL: WXsignature })
        if (!res) return
        // 分享链接授权签名信息
        signMap.set(authUrl, res.data.data)
        // 用微信SDK
        this.wxConfigJSSDK(res.data.data)
    },
    // 将签名信息更新到微信的SDK中
    wxConfigJSSDK(shareSign) {
        wx.config({
            debug: false, // 可打开调试，看是否成功和报错信息
            appId: shareSign.appId, // 必填，公众号的唯一标识
            timestamp: shareSign.timestamp, // 必填，生成签名的时间戳
            nonceStr: shareSign.nonceStr, // 必填，生成签名的随机串
            signature: shareSign.signature, // 必填，签名
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareAppMessage',
                'onMenuShareTimeline'
            ]
        })
        const { title, desc, shareLink, imgUrl } = wxShareConfig
        const shareData = {
            title,
            desc,
            link: shareLink, // 分享链接
            imgUrl
        }
        wx.ready(function (res) {
            wx.updateAppMessageShareData(shareData)
            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData(shareData)
            wx.onMenuShareAppMessage(shareData)
            wx.onMenuShareTimeline(shareData)
        })
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        wx.error(function (res) {
            console.log('error', res)
            console.log('分享失败: error', res)
        })
    }
}
// 导出工具类
export default wxShare



// WEBPACK FOOTER //
// ./src/mixins/wxShare.js